const COUNTRY_CODE_TO_CONTENTFUL_SHORT_DOMAIN_CODE = {
  AF: 'au',
  AX: 'za',
  AL: 'uk',
  DZ: 'za',
  AS: 'us',
  AD: 'uk',
  AO: 'za',
  AI: 'us',
  AQ: 'au',
  AG: 'us',
  AR: 'us',
  AM: 'uk',
  AW: 'us',
  AU: 'au',
  AT: 'uk',
  AZ: 'uk',
  BS: 'us',
  BH: 'uk',
  BD: 'au',
  BB: 'us',
  BY: 'uk',
  BE: 'uk',
  BZ: 'us',
  BJ: 'za',
  BM: 'us',
  BT: 'au',
  BO: 'us',
  BA: 'uk',
  BW: 'za',
  BV: 'za',
  BR: 'us',
  IO: 'au',
  BN: 'au',
  BG: 'uk',
  BF: 'za',
  BI: 'za',
  KH: 'za',
  CM: 'za',
  CA: 'ca',
  CV: 'za',
  KY: 'us',
  CF: 'za',
  TD: 'za',
  CL: 'us',
  CN: 'cn',
  CX: 'au',
  CC: 'au',
  CO: 'us',
  KM: 'za',
  CG: 'za',
  CD: 'za',
  CK: 'au',
  CR: 'us',
  CI: 'za',
  HR: 'uk',
  CU: 'us',
  CY: 'uk',
  CZ: 'uk',
  DK: 'uk',
  DJ: 'za',
  DM: 'us',
  DO: 'us',
  EC: 'us',
  EG: 'uk',
  SV: 'us',
  GQ: 'za',
  ER: 'za',
  EE: 'uk',
  ET: 'za',
  FK: 'uk',
  FO: 'uk',
  FJ: 'au',
  FI: 'uk',
  FR: 'uk',
  GF: 'us',
  PF: 'au',
  TF: 'au',
  GA: 'za',
  GM: 'za',
  GE: 'uk',
  DE: 'uk',
  GH: 'za',
  GI: 'uk',
  GR: 'uk',
  GL: 'uk',
  GD: 'us',
  GP: 'us',
  GU: 'us',
  GT: 'us',
  GG: 'uk',
  GN: 'za',
  GW: 'za',
  GY: 'us',
  HT: 'us',
  HM: 'au',
  VA: 'uk',
  HN: 'us',
  HK: 'au',
  HU: 'uk',
  IS: 'uk',
  IN: 'in',
  ID: 'au',
  IR: 'uk',
  IQ: 'uk',
  IE: 'uk',
  IM: 'uk',
  IL: 'uk',
  IT: 'uk',
  JM: 'us',
  JP: 'au',
  JE: 'uk',
  JO: 'uk',
  KZ: 'uk',
  KE: 'za',
  KI: 'au',
  KP: 'au',
  KR: 'kr',
  KW: 'uk',
  KG: 'uk',
  LA: 'au',
  LV: 'uk',
  LB: 'uk',
  LS: 'za',
  LR: 'za',
  LY: 'za',
  LI: 'uk',
  LT: 'uk',
  LU: 'uk',
  MO: 'au',
  MK: 'uk',
  MG: 'za',
  MW: 'za',
  MY: 'au',
  MV: 'au',
  ML: 'za',
  MT: 'uk',
  MH: 'au',
  MQ: 'us',
  MR: 'za',
  MU: 'au',
  YT: 'za',
  MX: 'us',
  FM: 'au',
  MD: 'uk',
  MC: 'uk',
  MN: 'au',
  ME: 'uk',
  MS: 'us',
  MA: 'uk',
  MZ: 'za',
  MM: 'au',
  NA: 'za',
  NR: 'au',
  NP: 'au',
  NL: 'uk',
  AN: 'us',
  NC: 'au',
  NZ: 'nz',
  NI: 'us',
  NE: 'za',
  NG: 'za',
  NU: 'au',
  NF: 'au',
  MP: 'au',
  NO: 'uk',
  OM: 'uk',
  PK: 'au',
  PW: 'au',
  PS: 'uk',
  PA: 'us',
  PG: 'au',
  PY: 'us',
  PE: 'us',
  PH: 'us',
  PN: 'us',
  PL: 'uk',
  PT: 'uk',
  PR: 'us',
  QA: 'uk',
  RE: 'za',
  RO: 'uk',
  RU: 'uk',
  RW: 'za',
  BL: 'us',
  SH: 'us',
  KN: 'us',
  LC: 'us',
  PM: 'us',
  VC: 'us',
  WS: 'au',
  SM: 'uk',
  ST: 'za',
  SA: 'uk',
  SN: 'za',
  RS: 'uk',
  SC: 'za',
  SL: 'za',
  SG: 'au',
  SK: 'uk',
  SI: 'uk',
  SB: 'au',
  SO: 'za',
  ZA: 'za',
  GS: 'us',
  ES: 'uk',
  LK: 'au',
  SD: 'za',
  SR: 'us',
  SJ: 'uk',
  SZ: 'za',
  SE: 'uk',
  CH: 'uk',
  SY: 'uk',
  WT: 'au',
  TJ: 'au',
  TZ: 'za',
  TH: 'th',
  TL: 'au',
  TG: 'za',
  TK: 'nz',
  TO: 'au',
  TT: 'us',
  TN: 'uk',
  TR: 'uk',
  TM: 'au',
  TC: 'us',
  TV: 'au',
  UG: 'za',
  UA: 'uk',
  AE: 'uk',
  GB: 'uk',
  US: 'us',
  UM: 'us',
  UY: 'us',
  UZ: 'au',
  VU: 'au',
  VE: 'us',
  VN: 'au',
  VG: 'us',
  VI: 'us',
  WF: 'nz',
  EH: 'za',
  YE: 'za',
  ZM: 'za',
  ZW: 'za',
} as const

const CONTENTFUL_DOMAIN_CODE_SHORT_TO_LONG = {
  au: 'Australia',
  ca: 'Canada',
  cn: 'China',
  uk: 'United Kingdom',
  in: 'India',
  kr: 'Korea',
  nz: 'New Zealand',
  th: 'Thailand',
  us: 'United States',
  za: 'South Africa',
} as const

type CountryCode = keyof typeof COUNTRY_CODE_TO_CONTENTFUL_SHORT_DOMAIN_CODE

type ContentfulShortDomainCode = keyof typeof CONTENTFUL_DOMAIN_CODE_SHORT_TO_LONG
type ContentfulLongDomainCode = (typeof CONTENTFUL_DOMAIN_CODE_SHORT_TO_LONG)[ContentfulShortDomainCode]

function isCountryCode(maybeCountryCode?: string): maybeCountryCode is CountryCode {
  return Object.keys(COUNTRY_CODE_TO_CONTENTFUL_SHORT_DOMAIN_CODE).includes(maybeCountryCode as CountryCode)
}

export function stringToCountryCode(maybeCountryCode?: string): CountryCode {
  if (isCountryCode(maybeCountryCode)) {
    return maybeCountryCode
  } else {
    return 'AU'
  }
}

export function getContentfulLongDomainCode(countryCode?: string): ContentfulLongDomainCode {
  return CONTENTFUL_DOMAIN_CODE_SHORT_TO_LONG[getContentfulShortDomainCode(countryCode)]
}

export function getContentfulShortDomainCode(countryCode?: string): ContentfulShortDomainCode {
  return COUNTRY_CODE_TO_CONTENTFUL_SHORT_DOMAIN_CODE[stringToCountryCode(countryCode)]
}
